module.exports = __webpack_public_path__ + "img/icon.c47a76ab.png";